import {removeLocalStorage} from "../helpers/local-storage";
import CoCartAPI from "@cocart/cocart-rest-api";
import {withCorrectPrice} from "../helpers/utils";

export const useSubmitQuote = () => {
    const CoCart = new CoCartAPI({
        url: "https://royaltubs.co.uk",
        version: "cocart/v2",
    });

    const mapItemsForZapier = (field) => {
        if(field) {
            if (Array.isArray(field)) {
                return field.length ? field.map(item => item.label).join(', ') : "none"
            }
            return field.label
        }
    }

    /**
     * To map items for coCart
     * @param field
     * @returns {*}
     */
    const mapItemToString = (field) => {
        if(field) {
            return (field.label ? ` (${field.label})` : "") +
                (field.variant ? ` (${field.variant})` : "") +
                (field.quantity ? ` x ${field.quantity}` : "") +
                (`(&#163;${withCorrectPrice(field)})`);
        }
    }
        

    /**
     * To map upgrades and other multiple items
     * @param field
     * @returns {*|string}
     */
    const mapArrayToString = (field) => {
        if (field) {
           return field.length ? field.map(mapItemToString).join(", ") : "none";
        }
    }

    /**
     * Submit coCart and get link for cart.
     * @param coCartData
     * @param size
     * @param totalPrice
     * @returns {Promise<string>}
     */
    const submitCoCart = ({coCartData, size, totalPrice}) => {
       return CoCart.post("cart/add-item", coCartData)
            .then((response) => {
                const cart_key = response.data.cart_key;
            return `https://royaltubs.co.uk/cart/?nocache&cocart-load-cart=${cart_key}`
            })
            .catch((error) => {
                console.error(error)
            })
    }

    /**
     * Root submit
     * @param submitData
     * @param type
     * @returns {Promise<void>}
     */
    const submitFormQuote = async (submitData, type) => {
        const link = await submitCoCart(submitData)
        const finalData = {
            link,
            ...submitData.zapierData
        }
        return await fetch('https://hooks.zapier.com/hooks/catch/1734238/bsk0psg', {
            method: 'POST',
            body: JSON.stringify(finalData),
        })
            .then(response => response.json())
            .then(response => {
                //console.log(response);
                //console.log(JSON.stringify(finalData));
            })
            .then(data => {
                removeLocalStorage(`${type}Configuration`);
                removeLocalStorage(`${type}FormStep`);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }

    return {
        submitFormQuote,
        mapArrayToString,
        mapItemsForZapier,
        mapItemToString,
    }
}
